import type React from 'react';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  useLocation();
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    // Reset to initial state before playing the enter animation
    el.classList.remove('opacity-100', 'translate-y-0');
    el.classList.add('opacity-0', 'translate-y-1');

    // Force reflow to ensure the transition runs when classes change
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    el.offsetHeight;

    el.classList.remove('opacity-0', 'translate-y-1');
    el.classList.add('opacity-100', 'translate-y-0');
  }, []);

  return (
    <div
      ref={containerRef}
      className="transition-all duration-200 ease-out will-change-transform will-change-opacity opacity-0 translate-y-1 motion-reduce:transition-none motion-reduce:transform-none motion-reduce:opacity-100"
    >
      {children}
    </div>
  );
};
